var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "box",
    {
      staticClass: "_flexcol",
      attrs: {
        content: "",
        "data-qa": `updates-feed-card:${_vm.projectUpdateID}`,
      },
    },
    [
      _c("backer-center-header", {
        staticClass: "_pa-2 _pa-3--m",
        scopedSlots: _vm._u(
          [
            _vm.projectImageUrl
              ? {
                  key: "prefix",
                  fn: function () {
                    return [
                      _c("backer-center-thumbnail", {
                        attrs: {
                          "image-url": _vm.projectImageUrl,
                          url: _vm.projectUrl,
                          name: _vm.projectName,
                        },
                      }),
                    ]
                  },
                  proxy: true,
                }
              : null,
            {
              key: "default",
              fn: function () {
                return [
                  _c(
                    "div",
                    { staticClass: "_flexcol _jc-c" },
                    [
                      _c(
                        "base-text",
                        {
                          attrs: {
                            as: "a",
                            level: "b1",
                            href: _vm.projectUrl,
                            "data-qa": "backer-center-update:ProjectName",
                          },
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.projectName) +
                              "\n                "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "base-text",
                        {
                          staticClass: "_tc--light",
                          attrs: {
                            as: "div",
                            level: "caption",
                            href: _vm.projectUrl,
                          },
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.formattedDate) +
                              "\n                "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
      }),
      _vm._v(" "),
      _c("base-divider", { staticClass: "_my-0" }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "_flex _gap-2 _gap-3--m _pa-2 _pa-3--m _ai-c _fd-c _fd-r--m",
        },
        [
          _vm.hasUpdateImage
            ? _c(
                "a",
                { attrs: { href: _vm.projectUpdateUrl } },
                [
                  _c("base-image", {
                    staticClass: "_rounded--common _bxsh--base",
                    attrs: {
                      width: _vm.updateImageSize,
                      height: _vm.updateImageSize,
                      src: _vm.imageUrl,
                      loading: "lazy",
                      alt: _vm.title,
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "_flexcol gfu-1of1" }, [
            _c(
              "span",
              {
                staticClass: "gfu-project-update__counter",
                attrs: { "data-qa": "backer-center-update:SequenceNumber" },
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(
                      _vm.Resources.format(
                        _vm.Resources.ProjectUpdates.UpdateSequenceNumberLabel,
                        _vm.sequenceNumber
                      )
                    ) +
                    "\n            "
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "a",
              { attrs: { href: _vm.projectUpdateUrl } },
              [
                _c(
                  "base-title",
                  {
                    staticClass: "_my-1",
                    attrs: {
                      as: "h2",
                      level: "h2",
                      "data-qa": "backer-center-update-title",
                    },
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.title) +
                        "\n                "
                    ),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "p",
              {
                staticClass: "_my-1",
                attrs: { "data-qa": "backer-center-update-abstract" },
              },
              [
                _vm._v(
                  "\n                " + _vm._s(_vm.abstract) + "\n            "
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "gfu-link gfu-link-underline _tc--accent",
                attrs: { href: _vm.projectUpdateUrl },
              },
              [
                _c(
                  "span",
                  {
                    staticClass: "gfu-link-underline__content _ttl",
                    attrs: { "data-qa": "backer-center-update:ReadMore" },
                  },
                  [_vm._v(_vm._s(_vm.Resources.Common.ReadMoreActionButton))]
                ),
                _vm._v(" "),
                _c("base-icon", {
                  staticClass: "_ml-h",
                  attrs: { name: "chevron-right" },
                }),
              ],
              1
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("base-divider", { staticClass: "_my-0" }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "_flex _ma-2 _ma-3--m" },
        [
          _c("base-icon", { attrs: { name: "thumbs-up" } }),
          _vm._v(" "),
          _c(
            "span",
            { attrs: { "data-qa": "backer-center-update:LikesCount" } },
            [_vm._v(" " + _vm._s(_vm.likesCount))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }